import { IProvince, IProvinceBody, IProvinceQuery } from 'src/types';
import { http } from 'src/utils';
import BaseService from './base.service';

export default class ProvinceService extends BaseService<IProvince, IProvinceQuery, IProvinceBody> {
  constructor() {
    super('/api/province');
  }

  public async getFull() {
    const { data } = await http.get<IProvince[]>(`${this.url}/full`);
    return data;
  }

  public async importExcel(obj: any) {
    const formData = new FormData();
    formData.append('file', obj);
    const { data } = await http.postForm<string>(`${this.url}/import`, formData);
    return data;
  }
}
